import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Investor from "./pages/Investor";
import Contact from "./pages/Contact";

function App() {
  const [currentLang, setCurrentLang] = useState('en');

  const handleLanguageChange = (lang) => {
    setCurrentLang(lang);
  };

  return (
    <div className="App bg-black min-h-screen">
      <BrowserRouter>
        <Header 
          currentLang={currentLang} 
          onLanguageChange={handleLanguageChange} 
        />
        
        <main>
          <Routes>
            <Route path="/" element={<Home currentLang={currentLang} />} />
            <Route path="/about" element={<About currentLang={currentLang} />} />
            <Route path="/services" element={<Services currentLang={currentLang} />} />
            <Route path="/investor" element={<Investor currentLang={currentLang} />} />
            <Route path="/contact" element={<Contact currentLang={currentLang} />} />
          </Routes>
        </main>
        
        <Footer currentLang={currentLang} />
      </BrowserRouter>
    </div>
  );
}

export default App;
